import { t } from '@/ui/i18n/i18n';

export enum SubscriptionStatus {
  Incomplete = 'incomplete',
  PastDue = 'past_due',
  Active = 'active',
  Trialing = 'trialing',
  RequiresAction = 'requires_action'
}

export enum SubscriptionSlugNickName {
  Professional = 'professional',
  ProfessionalNew = 'professional',
  Free = 'free'
}

export enum SubscriptionFreeLimits {
  NumberSeats = 5,
}

export const StripeDeclineCodes: Record<string, string> = {
  authentication_required: t('stripe-decline-codes.authentication_required'),
  approve_with_id: t('stripe-decline-codes.approve_with_id'),
  call_issuer: t('stripe-decline-codes.call_issuer'),
  card_not_supported: t('stripe-decline-codes.card_not_supported'),
  card_velocity_exceeded: t('stripe-decline-codes.card_velocity_exceeded'),
  currency_not_supported: t('stripe-decline-codes.currency_not_supported'),
  do_not_honor: t('stripe-decline-codes.do_not_honor'),
  do_not_try_again: t('stripe-decline-codes.do_not_try_again'),
  duplicate_transaction: t('stripe-decline-codes.duplicate_transaction'),
  expired_card: t('stripe-decline-codes.expired_card'),
  fraudulent: t('stripe-decline-codes.fraudulent'),
  generic_decline: t('stripe-decline-codes.generic_decline'),
  incorrect_number: t('stripe-decline-codes.incorrect_number'),
  incorrect_cvc: t('stripe-decline-codes.incorrect_cvc'),
  incorrect_pin: t('stripe-decline-codes.incorrect_pin'),
  incorrect_zip: t('stripe-decline-codes.incorrect_zip'),
  insufficient_funds: t('stripe-decline-codes.insufficient_funds'),
  invalid_account: t('stripe-decline-codes.invalid_account'),
  invalid_amount: t('stripe-decline-codes.invalid_amount'),
  invalid_cvc: t('stripe-decline-codes.invalid_cvc'),
  invalid_expiry_month: t('stripe-decline-codes.invalid_expiry_month'),
  invalid_expiry_year: t('stripe-decline-codes.invalid_expiry_year'),
  invalid_number: t('stripe-decline-codes.invalid_number'),
  invalid_pin: t('stripe-decline-codes.invalid_pin'),
  issuer_not_available: t('stripe-decline-codes.issuer_not_available'),
  lost_card: t('stripe-decline-codes.lost_card'),
  merchant_blacklist: t('stripe-decline-codes.merchant_blacklist'),
  new_account_information_available: t('stripe-decline-codes.new_account_information_available'),
  no_action_taken: t('stripe-decline-codes.no_action_taken'),
  not_permitted: t('stripe-decline-codes.not_permitted'),
  offline_pin_required: t('stripe-decline-codes.offline_pin_required'),
  online_or_offline_pin_required: t('stripe-decline-codes.online_or_offline_pin_required'),
  pickup_card: t('stripe-decline-codes.pickup_card'),
  pin_try_exceeded: t('stripe-decline-codes.pin_try_exceeded'),
  processing_error: t('stripe-decline-codes.processing_error'),
  reenter_transaction: t('stripe-decline-codes.reenter_transaction'),
  restricted_card: t('stripe-decline-codes.restricted_card'),
  revocation_of_all_authorizations: t('stripe-decline-codes.revocation_of_all_authorizations'),
  revocation_of_authorization: t('stripe-decline-codes.revocation_of_authorization'),
  security_violation: t('stripe-decline-codes.security_violation'),
  service_not_allowed: t('stripe-decline-codes.service_not_allowed'),
  stolen_card: t('stripe-decline-codes.stolen_card'),
  stop_payment_order: t('stripe-decline-codes.stop_payment_order'),
  testmode_decline: t('stripe-decline-codes.testmode_decline'),
  transaction_not_allowed: t('stripe-decline-codes.transaction_not_allowed'),
  try_again_later: t('stripe-decline-codes.try_again_later'),
  withdrawal_count_limit_exceeded: t('stripe-decline-codes.withdrawal_count_limit_exceeded'),
};
